<template>

<app-content :loading="is.loading">

	<app-content-head :title="(room) ? room.name : 'Submit event'" :inline-back="room" v-on:back="onBackClick" subtitle="Create your own event for other attendees to join." />

	<app-content-body v-if="!is.loading && is.failed" :is-call="true">

		<app-content-call icon="closed" title="Submissions closed" :text="$settings.schedule.events.submit.content" />
	
	</app-content-body>

	<template v-if="!is.loading && !is.failed">

		<com-rooms v-if="!room" :rooms="rooms" v-on:select="onRoomSelect"/>
		<com-form v-if="room" :room="room" :clone="clone" />

	</template>

</app-content>

</template>

<script>

import comRooms from './conventionschedulesubmit/Rooms'
import comForm from './conventionschedulesubmit/Form'

import Vue from 'vue'

export default {

	components: {
		'com-rooms': comRooms,
		'com-form': comForm
	},

	data: function() {
	
		return {
			is: {
				loading: true,
				failed: false
			},
			clone: '',
			rooms: [],
			room: false
		}

	},

	created: function() {

		this.clone = this.$route.query.clone

		this.load()

	},

	methods: {

		onBackClick: function() {
		
			this.room = false
		
		},

		onRoomSelect: function(room) {
		
			Vue.set(this, 'room', room)

		},

		load: function() {
		
			this.$api.get('convention/schedule/submit').then(function(json) {

				this.rooms = json.rooms

				if (this.rooms.length === 1) Vue.set(this, 'room', json.rooms[0])
			
				this.is.loading = false
			
			}.bind(this), function() {

				this.is.failed = true
				this.is.loading = false
			
			}.bind(this))

		}
	
	}

}

</script>

<style scoped>

</style>